import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=339ac3a6&scoped=true"
import script from "./Separator.vue?vue&type=script&lang=js"
export * from "./Separator.vue?vue&type=script&lang=js"
import style0 from "./Separator.vue?vue&type=style&index=0&id=339ac3a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339ac3a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('339ac3a6')) {
      api.createRecord('339ac3a6', component.options)
    } else {
      api.reload('339ac3a6', component.options)
    }
    module.hot.accept("./Separator.vue?vue&type=template&id=339ac3a6&scoped=true", function () {
      api.rerender('339ac3a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/Separator.vue"
export default component.exports